import AppStateModel from './../../../model/appStateModel';

let _averagesMap = null;

export default class CohortTableModel {

    static get averagesMap() {
        return _averagesMap;
    }

    static set averagesMap(value) {
        _averagesMap = value;
    }

    static getResultsByBirthdayAndGender(birthday = AppStateModel.birthday, gender = AppStateModel.gender, subset = 'all') {
        
        if (!birthday || !gender) {
            return {
                'prognosis': {},
                'averages': {}
            };
        }
        
        return {
            'period': AppStateModel.getResultsByBirthdayAndGender(birthday, gender, AppStateModel.birthdayMap).p,
            'cohort': AppStateModel.getResultsByBirthdayAndGender(birthday, gender, AppStateModel.birthdayMap).k}
    }
}
